import { Link as RouterLink } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import {
  Box,
  Card,
  Link,
  Container,
  Typography,
  Paper,
  Stack,
} from "@mui/material";
// layouts
import AuthLayout from "../../layout/AuthLayout";
// components
import Page from "../Page";
import { MHidden } from "../@material-extend";
import LoginForm from "../authentication/login/LoginForm";
import AuthSocial from "../authentication/AuthSocial";
import login_banner from "../../image/login_banner.png";
import GooglePlay from "../../image/android-download.svg";
import AppStore from "../../image/app-store.png";
import { DomainText } from "../chargeMiles/DomainText";
import { useDomainConfig } from "../../hooks/useDomainConfig";

// ----------------------------------------------------------------------
const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 464,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const domainConfig = useDomainConfig();

  return (
    <RootStyle title="Register UI">
      <AuthLayout>
        Don’t have an account? &nbsp;
        <Link
          underline="none"
          variant="subtitle2"
          component={RouterLink}
          to="/register"
        >
          Get Started
        </Link>
      </AuthLayout>


      <Container className="cm-login-container">
        <ContentStyle>
          <Box sx={{ mb: 5 }}>
            <Typography variant="h6" gutterBottom>
              Sign in to <DomainText />
            </Typography>
            <Typography sx={{ color: "text.secondary" }}>
              Enter your details below.
            </Typography>
          </Box>


          <LoginForm />

          <AuthSocial />


          <Typography
            variant="body2"
            align="center"
            sx={{ color: "text.secondary", mt: 3 }}
          >
            By login, I agree to <DomainText />
            &nbsp;
            <Link
              href={domainConfig.termsAndConditionUrl}
              target="_blank"
              underline="always"
              sx={{ color: "primary" }}
            >
              Terms of Service
            </Link>
            &nbsp;and&nbsp;
            <Link
              href={domainConfig.privacyPolicyUrl}
              target="_blank"
              underline="always"
              sx={{ color: "primary" }}
            >
              Privacy Policy
            </Link>
            .
          </Typography>

          <MHidden width="smUp">
            <Typography variant="subtitle2" sx={{ mt: 3, textAlign: "center" }}>
              Don’t have an account?&nbsp;
              <Link to="/register" component={RouterLink}>
                Get Started
              </Link>
            </Typography>
          </MHidden>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={4}
            className="apps-stack"
          >
            <Typography variant="h6">Download Now</Typography>
            <Box className="cm-apps">
              <a
                href={domainConfig.appStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sr-only">Get it on App Store</span>
                <picture>
                  <source media="" type="image/svg" />
                  <img
                    className="image"
                    src={AppStore}
                    alt="Get it on App Store"
                    loading="lazy"
                  />
                </picture>
              </a>
            </Box>
            <Box className="cm-apps">
              <a
                href={domainConfig.playStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sr-only">Get it on Google Play</span>
                <picture>
                  <source media="" type="image/svg" />
                  <img
                    className="image"
                    src={GooglePlay}
                    alt="Get it on Google Play"
                    loading="lazy"
                  />
                </picture>
              </a>
            </Box>
          </Stack>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
